export class CustomerRequest {
    name: string;
    nameId: string;
    city: string;
    phoneNumber: string;
    constructor() {
        this.name = '';
        this.city = '';
        this.nameId = '';
        this.phoneNumber = '';
    }
}